"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccessToken = exports.clearRemoteAuthTokenSilently = exports.getRemoteAuthTokenSilently = exports.clearAuthToken = exports.getAuthToken = exports.setAuthToken = void 0;
const configs_constants_1 = require("../constants/configs.constants");
const runIframe_1 = require("../utils/runIframe");
/**
 * INTERNAL FUNCTIONS
 */
/**
 * @function setAuthToken
 * @description sets arbitrary auth token content in user's local storage
 * @param {any} authTokenContentObj
 * @returns {void}
 */
const setAuthToken = (authTokenContentObj) => {
    localStorage.setItem(configs_constants_1.AUTH_TOKEN_NAME, JSON.stringify(authTokenContentObj));
};
exports.setAuthToken = setAuthToken;
/**
 * @function getAuthToken
 * @description used internally to get the content of the auth token
 * @returns {void}
 */
const getAuthToken = () => {
    const unparsedToken = localStorage.getItem(configs_constants_1.AUTH_TOKEN_NAME);
    if (!unparsedToken) {
        return null;
    }
    return JSON.parse(unparsedToken);
};
exports.getAuthToken = getAuthToken;
/**
 * @function clearAuthToken
 * @description clears / removes the auth token
 * @returns {void}
 */
const clearAuthToken = (tokenIdentifier) => {
    localStorage.removeItem(tokenIdentifier);
};
exports.clearAuthToken = clearAuthToken;
/**
 * @function getRemoteAuthTokenSilently
 * @description attempts to fetch auth token from remote auth domain via iframe
 * @returns {Promise<any | Error>}
 */
const getRemoteAuthTokenSilently = (urls) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const value = yield (0, runIframe_1.runLoginIframe)(urls);
        if (!value) {
            return null;
        }
        return value;
    }
    catch (error) {
        return null;
    }
});
exports.getRemoteAuthTokenSilently = getRemoteAuthTokenSilently;
/**
 * @function clearRemoteAuthTokenSilently
 * @description used internally to conduct TE wide logout from all products
 * @param urls
 * @returns
 */
const clearRemoteAuthTokenSilently = (urls) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const result = yield (0, runIframe_1.runLogoutIframe)(urls);
        return !!(result.status && result.status === 'SUCCESS');
    }
    catch (error) {
        return false;
    }
});
exports.clearRemoteAuthTokenSilently = clearRemoteAuthTokenSilently;
/**
 * EXTERNAL FUNCTIONS
 */
/**
 * @function getAccessToken
 * @description used by external libraries to get the access token to use in authenticated API callse
 * @returns {string | null}
 */
const getAccessToken = () => {
    var _a;
    const unparsedToken = localStorage.getItem(configs_constants_1.AUTH_TOKEN_NAME);
    if (!unparsedToken)
        return null;
    try {
        const parsedToken = JSON.parse(unparsedToken);
        return (_a = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.accessToken) !== null && _a !== void 0 ? _a : null;
    }
    catch (e) {
        return null;
    }
};
exports.getAccessToken = getAccessToken;
